<ng-template>
	<div
		(@transformPopover.done)="_onAnimationDone($event)"
		[@transformPopover]="{ value: state, params: params }"
		[ngClass]="_classList"
		#focusTrapElement
		class="sat-popover-container"
	>
		<mat-card class="mat-elevation-z6 flex flex-col">
			<mat-form-field
				appearance="fill"
				class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain w-full"
			>
				<mat-icon matPrefix>search</mat-icon>
				<input
					[formControl]="search"
					[placeholder]="'reports.filter.typeSearch' | translate"
					matInput
					type="text"
				>
				<button
					(click)="search.setValue('')"
					*ngIf="search?.value"
					mat-icon-button
					matSuffix
				>
					<mat-icon>clear</mat-icon>
				</button>
			</mat-form-field>
			<div class="mt-1 flex flex-row items-center justify-start gap-2">
				<div class="!ml-auto flex flex-row items-center justify-start">
					<div
						(click)="this.selectAllAbsences()"
						class="cursor-pointer p-2 text-sm font-bold"
						translate
					>
						reports.toggles.allAbsences
					</div>
					<div
						(click)="this.selectNone()"
						class="cursor-pointer p-2 text-sm font-bold"
						translate
					>
						reports.toggles.none
					</div>
				</div>
			</div>
			<div class="-mx-16px"><mat-divider inset></mat-divider></div>
			<mat-list class="-mx-16px pt-0">
				<cdk-virtual-scroll-viewport
					[itemSize]="48"
					class="h-64"
				>
					<mat-list-item
						(click)="$event.preventDefault(); $event.stopPropagation(); this.selectItem(item.typeId)"
						(keydown.enter)="$event.preventDefault(); $event.stopPropagation(); this.close()"
						(keydown.space)="$event.preventDefault(); $event.stopPropagation(); this.selectItem(item.typeId)"
						*cdkVirtualFor="let item of items$filtered.value$ | async; trackBy: trackId"
						class="cursor-pointer"
						matRipple
					>
						<div
							[ngClass]="!item.useTranslate ? 'ml-6' : ''"
							class="flex-mw flex flex-row items-center justify-start gap-2"
						>
							<mat-checkbox
								[checked]="item.selected"
								class="mat-checkbox-flex"
								color="primary"
							></mat-checkbox>
							<div class="l-initial gap-x-2 mat-truncate flex flex-row">
								<div
									[ngClass]="
                    item.type === 'work'
                      ? 'size-6  p-0 leading-6  border  border-green-400  bg-green-600/90  dark:bg-green-600/60  text-green-200'
                      : item.type === 'absence'
                        ? 'size-6 p-0 leading-6  border  border-violet-400  bg-violet-800/90  dark:bg-violet-800/60  text-violet-100'
                        : item.type === 'pause'
                          ? 'size-6  p-0 leading-6  dark:bg-neutral-600 bg-neutral-600/80'
                          : 'size-6 p-0 leading-6  border  border-violet-400  bg-violet-800/90  dark:bg-violet-800/60  text-violet-100'
                  "
									class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100"
								>
									<mat-icon
										class="text-center"
										inline
									>
										{{ iconMap[item.type] }}
									</mat-icon>
								</div>
								<span class="mat-truncate place-self-start">{{ item | workinghoursType }}</span>
							</div>
						</div>
					</mat-list-item>
				</cdk-virtual-scroll-viewport>
			</mat-list>
		</mat-card>
	</div>
</ng-template>
